import React from "react";

interface CustomerCareExpenseData {
  actualExpense: string; budget: string; percentOfBudget: string;
  bonusPercentEarned: string; bonusValue: string; score: string;
}
interface CustomerCareExpenseSubFormProps {
  data: CustomerCareExpenseData; isEditable: boolean;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>, options?: { type?: 'number' | 'decimal' | 'text'; maxLength?: number; minLength?: number; max?: number; min?: number }) => void;
}

const CustomerCareExpenseSubForm: React.FC<CustomerCareExpenseSubFormProps> = ({ data, isEditable, onInputChange }) => (
  <div className="sf-section">
    <h3 className="sf-title">Customer Care Expense (10% of total achievement score)</h3>
    <p className="sf-subtitle">This will be evaluated from monthly financial reports. The goal is meet budget.</p>
    <div className="grid grid-cols-2 gap-6">
      <div />
      <div className="space-y-4">
        <div>
          <label className="sf-label">Actual Expense</label>
          <div className="relative">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm" style={{ color: "var(--text-muted)" }}>$</span>
            <input type="text" name="operationalEfficiency.customerCareExpense.actualExpense"
              inputMode="numeric" maxLength={9} minLength={1}
              value={data.actualExpense && data.actualExpense !== "0" && !isNaN(Number(data.actualExpense)) ? parseFloat(data.actualExpense).toLocaleString() : ""}
              disabled={!isEditable} placeholder="0" onFocus={e => e.target.select()}
              onChange={e => onInputChange(e, { type: "number", maxLength: 9, minLength: 1 })}
              className="sf-input mt-1 block w-full pl-8 pr-3 py-2 text-right" />
          </div>
        </div>
        <div>
          <label className="sf-label">Budget</label>
          <div className="relative">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm" style={{ color: "var(--text-muted)" }}>$</span>
            <input type="text" name="operationalEfficiency.customerCareExpense.budget"
              inputMode="numeric" maxLength={9} minLength={1}
              value={data.budget && data.budget !== "0" && !isNaN(Number(data.budget)) ? parseFloat(data.budget).toLocaleString() : ""}
              disabled={!isEditable} placeholder="0" onFocus={e => e.target.select()}
              onChange={e => onInputChange(e, { type: "number", maxLength: 9, minLength: 1 })}
              className="sf-input mt-1 block w-full pl-8 pr-3 py-2 text-right" />
          </div>
        </div>
        <div>
          <label className="sf-label">% of Budget</label>
          <input type="text" readOnly name="operationalEfficiency.customerCareExpense.percentOfBudget"
            value={data.percentOfBudget && data.percentOfBudget !== "0" && !isNaN(Number(data.percentOfBudget)) ? parseFloat(data.percentOfBudget).toFixed(0) : "0"}
            className="sf-input-ro mt-1 block w-full px-3 py-2 text-right" />
        </div>
      </div>
    </div>
    <p className="sf-hint">70%–120% of Goal</p>
    <div className="sf-results grid grid-cols-4 gap-4">
      <div>
        <div className="sf-results-label">Bonus % Earned</div>
        <input type="text" readOnly name="operationalEfficiency.customerCareExpense.bonusPercentEarned"
          value={data.bonusPercentEarned && data.bonusPercentEarned !== "0" && !isNaN(Number(data.bonusPercentEarned)) ? parseFloat(data.bonusPercentEarned).toFixed(0) : "0"}
          className="sf-input-ro w-24 px-2 py-1 text-right" />
      </div>
      <div>
        <div className="sf-results-label">10%</div>
        <input type="text" readOnly name="operationalEfficiency.customerCareExpense.bonusValue"
          value={data.bonusValue && data.bonusValue !== "0" && !isNaN(Number(data.bonusValue)) ? parseFloat(data.bonusValue).toFixed(2) : "0.10"}
          className="sf-input-ro w-24 px-2 py-1 text-right" />
      </div>
      <div>
        <div className="sf-results-label">Score</div>
        <input type="text" readOnly name="operationalEfficiency.customerCareExpense.score"
          value={data.score && data.score !== "0" && !isNaN(Number(data.score)) ? parseFloat(data.score).toFixed(0) : "0"}
          className="sf-input-ro w-24 px-2 py-1 text-right" />
      </div>
    </div>
  </div>
);

export default CustomerCareExpenseSubForm;